import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { analytics } from '@/lib/analytics';
import { useAuth } from './useAuth';

export const useAnalytics = () => {
  const location = useLocation();
  const { user } = useAuth();

  // Track page views
  useEffect(() => {
    const pageName = location.pathname.replace('/', '') || 'dashboard';
    analytics.page(pageName, {
      path: location.pathname,
      search: location.search,
    });
  }, [location]);

  // Identify user when authenticated
  useEffect(() => {
    if (user) {
      analytics.identify({
        userId: user.id,
        email: user.email,
        // Add more user properties as needed
      });
    }
  }, [user]);

  return {
    track: analytics.track.bind(analytics),
    identify: analytics.identify.bind(analytics),
    page: analytics.page.bind(analytics),
    campaignCreated: analytics.campaignCreated.bind(analytics),
    callInitiated: analytics.callInitiated.bind(analytics),
    callCompleted: analytics.callCompleted.bind(analytics),
    leadImported: analytics.leadImported.bind(analytics),
    subscriptionChanged: analytics.subscriptionChanged.bind(analytics),
    featureUsed: analytics.featureUsed.bind(analytics),
  };
};